import { render, staticRenderFns } from "./CorporatePayment.vue?vue&type=template&id=1a2eecd0&scoped=true"
import script from "./CorporatePayment.vue?vue&type=script&lang=js"
export * from "./CorporatePayment.vue?vue&type=script&lang=js"
import style0 from "./CorporatePayment.vue?vue&type=style&index=0&id=1a2eecd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2eecd0",
  null
  
)

export default component.exports